import { useJourneySelectorModal } from './journey-selector-modal';
import { useTriggerConfigSidebar } from './trigger-config-sidebar';

export type AddStageTriggerOptions = {
  isAdmin: boolean;
  /** Forwarded to the config sidebar that opens once a journey is picked. */
  onConfigClose?: () => void;
};

/**
 * The add-stage-trigger flow shared by the triggers sidebar and the stage
 * action menu: journey selector modal → config sidebar, which creates the
 * trigger when it is saved. Picking a journey persists nothing on its own, so
 * dismissing the config sidebar leaves the job as it was.
 */
export const useAddStageTrigger = (jobId: number) => {
  const showSelectorModal = useJourneySelectorModal();
  const openConfigSidebar = useTriggerConfigSidebar();

  const addStageTrigger = (stageId: number, { isAdmin, onConfigClose }: AddStageTriggerOptions) => {
    showSelectorModal({
      jobId,
      triggerType: 'stage',
      jobStage: stageId,
      isAdmin,
      onSelect: (journey) => {
        openConfigSidebar({
          jobId,
          journeyId: journey.journeyId,
          journeyTitle: journey.title,
          pendingTrigger: { triggerType: 'stage', jobStage: stageId },
          onClose: onConfigClose,
        });
      },
    });
  };

  return { addStageTrigger };
};
